var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center flex-wrap mb-md-6 mb-3 mr-3",class:_vm.onlyHeader ? 'justify-space-between' :''},[_c('h1',{staticClass:"page-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }